import { jsx as _jsx } from "react/jsx-runtime";
import { LoadingOutlined } from "@ant-design/icons";
import { Spin } from "antd";
import { DummyPage } from "./Redirect";
const spinSizes = {
    small: 18,
    medium: 24,
    large: 36,
    huge: 54,
};
const LoadingIcon = ({ size }) => (_jsx(LoadingOutlined, { style: { fontSize: spinSizes[size || "medium"] }, spin: true }));
export const Loading = (props) => (_jsx(Spin, { indicator: _jsx(LoadingIcon, { ...props }) }));
export const LoadingPadded = (props) => (_jsx("div", { style: {
        padding: "2rem",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
    }, children: _jsx(Loading, { ...props }) }));
export const PageLoading = () => {
    return (_jsx(DummyPage, { children: _jsx(LoadingPadded, { size: "large" }) }));
};
//# sourceMappingURL=Loading.js.map